import React, { createContext, useState, useRef, useCallback } from 'react';
import { preloadImages, collectCatalogImageUrls } from '@/lib/imageCache';

export const OrderPageContext = createContext(null);

export function OrderPageProvider({ children }) {
  const [orderPageControls, setOrderPageControls] = useState(null);
  // In-memory catalog cache: { [locationId]: { categories, last_synced } }
  const catalogCache = useRef({});

  const getCachedCatalog = useCallback((locationId) => {
    return catalogCache.current[locationId] || null;
  }, []);

  const setCachedCatalog = useCallback((locationId, categories) => {
    catalogCache.current[locationId] = { categories, ts: Date.now() };
    preloadImages(collectCatalogImageUrls(categories));
  }, []);

  return (
    <OrderPageContext.Provider value={{ orderPageControls, setOrderPageControls, getCachedCatalog, setCachedCatalog }}>
      {children}
    </OrderPageContext.Provider>
  );
}